/**
 * Returns a boolean indicating that the project runs in development
 * @returns boolean
 */
export const isDev = process.env.NODE_ENV !== 'production';

/**
 * Logs messages to the console in development mode only
 * @param message The message
 * @param optionalParams Params
 */
export const log = (message?: any, ...optionalParams: any[]) => {
  if (!isDev) return;

  console.log(message, optionalParams);
};
